import React, { useState } from "react";
import UniversalModuleModal from "./UniversalModuleModal";
import { MODULE_MODAL_CONFIGS } from "./moduleModalConfigs";

const MainPage = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleConfirm = (values) => {
    console.log("Form values:", values);
    setIsModalOpen(false);
  };

  return (
    <div>
      <button onClick={() => setIsModalOpen(true)}>
        Open Modal
      </button>

      <UniversalModuleModal
        isVisible={isModalOpen}
        config={MODULE_MODAL_CONFIGS.exponential}
        onClose={() => setIsModalOpen(false)}
        onConfirm={handleConfirm}
      />
    </div>
  );
};

export default MainPage;